export default __webpack_public_path__ + "images/c182f607759073aee5ba505a038ccf93-shintoism_small.webp";